import { ball, body, coverBg, edge, fade, gloss, mix, n, shade, shadowInk, tint, warm, type ArtPal } from './kit';

/** Garden: a sunny vegetable bed — pumpkin, carrot, tomato under a smiling-free sun (scene of the slot symbols). */
export function gardenCover(P: ArtPal, p: string): string {
  const top = P.dark ? mix(P.bg, P.sky, 0.14) : tint(P.sky, 0.82);
  const mid = P.dark ? mix(P.panel, P.green, 0.12) : tint(P.gold, 0.86);
  const bottom = P.dark ? mix(P.bg, P.green, 0.1) : tint(P.green, 0.8);
  const bg = coverBg(p, P, top, mid, bottom, [470, 120]);
  const soil = P.dark ? mix(P.orange, P.bg, 0.72) : mix(P.orange, '#FFFFFF', 0.45);
  const leaf = P.green;

  // sun rays: rounded petals around the sun
  const sx = 540;
  const sy = 92;
  const rays: string[] = [];
  for (let i = 0; i < 12; i++) {
    const a = (i / 12) * 360;
    rays.push(`<rect x="${sx - 5}" y="${sy - 74}" width="10" height="22" rx="5" transform="rotate(${a} ${sx} ${sy})" fill="${warm(P)}" fill-opacity=".8"/>`);
  }

  const leafPath = (x: number, y: number, rot: number, s = 1) =>
    `<path d="M0 0C-6 -18 -2 -36 10 -46C16 -30 14 -12 0 0Z" transform="translate(${x} ${y}) rotate(${rot}) scale(${s})" fill="url(#${p}lf)" stroke="${edge(leaf, P)}" stroke-width="1.6" stroke-linejoin="round"/>`;

  // pumpkin lobes
  const pk = (x: number, y: number) =>
    `<g transform="translate(${x} ${y})">` +
    `<ellipse cx="-34" cy="0" rx="34" ry="46" fill="url(#${p}pk)" stroke="${edge(P.orange, P)}" stroke-width="2"/>` +
    `<ellipse cx="34" cy="0" rx="34" ry="46" fill="url(#${p}pk)" stroke="${edge(P.orange, P)}" stroke-width="2"/>` +
    `<ellipse cx="0" cy="0" rx="36" ry="50" fill="url(#${p}pk)" stroke="${edge(P.orange, P)}" stroke-width="2"/>` +
    `<path d="M-4 -48C-6 -60 -2 -70 8 -74" fill="none" stroke="${shade(leaf, 0.2)}" stroke-width="8" stroke-linecap="round"/>` +
    leafPath(8, -48, 60, 0.9) +
    gloss(-12, -26, 12, 6, -40, 0.5) +
    `</g>`;

  const defs =
    `<defs>${bg.defs}` +
    fade(`${p}sh`, shadowInk(P), P.dark ? 0.5 : 0.18) +
    ball(`${p}sun`, warm(P), 0.5, 0.25) +
    fade(`${p}halo`, P.gold, P.dark ? 0.25 : 0.4) +
    body(`${p}soil`, soil, 0.2, 0.3, 0.3, 1) +
    body(`${p}lf`, leaf, 0.35, 0.3, 0.6, 1) +
    ball(`${p}pk`, P.orange, 0.4, 0.4) +
    ball(`${p}tm`, P.red, 0.45, 0.4) +
    body(`${p}cr`, P.orange, 0.35, 0.3, 1, 0.4) +
    `</defs>`;

  // carrot (tilted, half in the soil)
  const carrot =
    `<g transform="translate(372 234) rotate(-16)">` +
    leafPath(-4, -60, -30, 1.1) +
    leafPath(4, -62, 10, 1.25) +
    leafPath(10, -58, 45, 1) +
    `<path d="M-24 -60Q0 -70 24 -60L4 60Q0 66 -4 60Z" fill="url(#${p}cr)" stroke="${edge(P.orange, P)}" stroke-width="2" stroke-linejoin="round"/>` +
    `<path d="M-14 -30H-2M8 -8H18M-10 14H0M4 34H10" stroke="${edge(P.orange, P)}" stroke-width="2.5" stroke-linecap="round" stroke-opacity=".6"/>` +
    gloss(-10, -46, 10, 4, -8, 0.5) +
    `</g>`;

  const tomato =
    `<g transform="translate(582 268)">` +
    `<circle cx="0" cy="0" r="40" fill="url(#${p}tm)" stroke="${edge(P.red, P)}" stroke-width="2"/>` +
    `<path d="M0 -40L7 -52L10 -38L22 -44L14 -32L-14 -32L-22 -44L-10 -38L-7 -52Z" fill="url(#${p}lf)" stroke="${edge(leaf, P)}" stroke-width="1.6" stroke-linejoin="round"/>` +
    gloss(-15, -16, 11, 6, -40, 0.55) +
    `</g>`;

  return (
    defs +
    bg.body +
    `<circle cx="${sx}" cy="${sy}" r="96" fill="url(#${p}halo)"/>` +
    rays.join('') +
    `<circle cx="${sx}" cy="${sy}" r="44" fill="url(#${p}sun)" stroke="${edge(P.gold, P)}" stroke-width="2"/>` +
    gloss(sx - 16, sy - 17, 13, 7, -40, 0.6) +
    // soil mound
    `<path d="M170 400C200 318 330 290 460 292C570 294 640 318 640 330V400Z" fill="url(#${p}soil)" stroke="${edge(soil, P)}" stroke-width="2"/>` +
    `<path d="M260 336C320 326 380 322 440 324M300 362C360 352 430 350 500 352M470 330C520 328 580 332 620 342" fill="none" stroke="${shade(soil, 0.25)}" stroke-width="3" stroke-linecap="round" stroke-opacity=".5"/>` +
    carrot +
    `<ellipse cx="${n(470)}" cy="338" rx="96" ry="12" fill="url(#${p}sh)"/>` +
    pk(470, 280) +
    `<ellipse cx="584" cy="312" rx="46" ry="8" fill="url(#${p}sh)"/>` +
    tomato
  );
}
